module.exports = __webpack_public_path__ + "img/specialTopic.0fb2d642.png";